<template>
  <div>
    <v-card class="box">
      <v-row fluid justify="center">
        <v-radio-group v-model="print_type" row>
          <v-radio label="Print Bulk Icards" value="Bulk"></v-radio>
          <v-radio label="Print Specific Icards" value="Specific"></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="print_type == 'Bulk'">
          <br />
          <v-row dense justify="center">
            <v-col sm="3" md="3">
              <v-autocomplete class="no-display" :items="std_list" item-value="id" item-text="standard" v-model="std"
                label="Search Standard" dense rounded outlined color="#0F2027"></v-autocomplete>
            </v-col>
            <v-col sm="3" md="3">
              <v-autocomplete class="no-display" :items="div_list" item-value="id" item-text="division" v-model="div"
                label="Search Division" dense rounded outlined color="#0F2027"></v-autocomplete>
            </v-col>
            <v-col sm="2" md="2">
              <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
                item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
            </v-col>
            <v-col sm="2">
              <v-text-field dense rounded required outlined persistent-hint hint="Items Per Pages"
                v-model="itemsPerPage" label="Items Per Pages"></v-text-field>
            </v-col>
          </v-row>
          <br />
          <v-row dense justify="center">
            <v-col sm="3" md="3" v-if="std && div && status">
              <v-btn color="primary" @click="bulkStudent">Proceed to bulk
                <span class="i-card"> student </span>icard print</v-btn>
            </v-col>
            <v-col sm="4" md="4" v-if="std && div && status">
              <v-btn color="primary" @click="getRemainingStudentData()">Get <span class="i-card"> Incomplete / Blocked
                </span> Student's List</v-btn>
            </v-col>
          </v-row>
      </template>
      <template v-if="print_type == 'Specific'">
          <br />
          <v-row justify="center" dense>
            <v-col sm="5">
              <v-textarea v-model="prn" color="#0F2027" rounded dense label="Enter Comma Seperated PRN"
                outlined></v-textarea>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col sm="3" v-if="prn">
              <v-btn color="primary" @click="getStudentIcardSpecificPRN()">Proceed To <span class="i-card">
                  Student</span>Icard print</v-btn>
            </v-col>
          </v-row>
      </template>
    </v-card>
    <v-card class="box" v-if="icard_data_rem_students != '' && print_type != 'Specific'">
      <v-data-table :headers="headers" dense :items="icard_data_rem_students" class="elevation-1 mytable"
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Students</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field style="color: white;background-color: white;" v-model="search" append-icon="search"
              label="Search" single-line hide-details> </v-text-field>
          </v-toolbar>
        </template>
        <template v-slot:[`item.icard_blocked`]="{ item }">
          <span v-if="item.icard_blocked">
            <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import QrcodeVue from "qrcode.vue";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
  data: () => ({
    prn: "",
    search: "",
    comp_load: false,
    stud_list: null,
    radios: null,
    radios1: null,
    stud_data: null,
    child_data: null,
    print_type: null,
    std_list: null,
    div_list: null,
    std: null,
    div: null,
    itemsPerPage: 10,
    icard_data_rem_students: [],
    headers: [
      {
        text: "Student",
        align: "left",
        sortable: false,
        value: "grno",
      },
      {
        text: "Data Remaining",
        align: "left",
        sortable: false,
        value: "icard_fields_remaining",
      },
      {
        text: "Is Icard Blocked?",
        align: "left",
        sortable: false,
        value: "icard_blocked",
      },
    ],
    for: null,
    usertype: null,
    status_list: [
      { name: "Active", id: "0" },
      { name: "Temporary Inactive", id: "1" },
      { name: "Permanent Inactive", id: "2" },
    ],
    status: null,
    active_status: null,
    academic_year_list: [],
    ay: "",
    icard_data: [],
    common_data: [],
  }),
  mounted() {
    this.onload();
    localStorage.setItem("icard_data", null);
    localStorage.setItem("common_data", null);
  },
  methods: {
    bulkStudent() {
      this.usertype = "Student";
      localStorage.setItem("icard_ay_id", this.ay);
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      localStorage.setItem("itemsPerPage", this.itemsPerPage);
      localStorage.setItem("for", JSON.stringify(this.print_type));
      localStorage.setItem("usertype", JSON.stringify(this.usertype));
      let routeData = this.$router.resolve({
        name: "tmv-bulk-icard-print",
      });
      window.open(routeData.href, "_blank");
    },
    onload() {
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents1")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
            this.std_list = res.data.std_list;
            this.div_list = res.data.div_list;
            this.academic_year_list = res.data.academic_year_list;
            this.ay = res.data.current_ay;
          } else {
            alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    getRemainingStudentData() {
      this.icard_data_rem_students = [];
      const data = {
        std: this.std,
        div: this.div,
        status: this.status,
      };
      axios
        .post("/Icard/getIcardIncompleteStudent", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data_rem_students = res.data.icard_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    getStudentIcardSpecificPRN() {
      localStorage.setItem("prn", JSON.stringify(this.prn));
      let routeData = this.$router.resolve({
        name: "tmv-specific-card-print",
      });
      window.open(routeData.href, "_blank");      
    },
  },
};
</script>
<style scoped>
@media print {

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    font-size: xx-large !important;
  }

  v-card {
    border: none !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pagebreak {
    page-break-before: always !important;
    height: 200px;
  }

  @page {
    margin: -1.2645833mm;
    size: 53mm 85mm;
  }
}
.i-card {
  color: greenyellow;
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
}
</style>